import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { MyNotesAction } from "../actions";

export default class MyNotesMiddleware {
  static *getNote({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/mynote/${payload.username}`
      );

      if (res?.status === 200) {
        yield put(MyNotesAction.getNoteSuccess(res.data?.data));
      } else {
        yield put(MyNotesAction.getNoteFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(MyNotesAction.getNoteFailure());
    }
  }
  static *getNotes({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/mynotes?sort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(MyNotesAction.getNotesSuccess(res.data?.data));
      } else {
        yield put(MyNotesAction.getNotesFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(MyNotesAction.getNotesFailure());
    }
  }
  static *setNotes({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post(`/activity/mynote`, payload);

      if (res.status === 200) {
        yield put(MyNotesAction.setNotesSuccess(res.data.Data));
        message.success(res.data.message);
      } else {
        message.error(res.data.message);
        yield put(MyNotesAction.setNotesFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(MyNotesAction.setNotesFailure());
    }
  }
}
